// @todo once the source plugin is updated to the latest WPGQL version, we wont need this helper anymore
export const convertTime = (startTime, endTime) => {
    const startDS = new Date(startTime.replace(/\s/, 'T'))
    const endDS = new Date(endTime.replace(/\s/, 'T'))

    let startTimeAMPM = formatAMPM(startDS)
    let endTimeAMPM = formatAMPM(endDS)

    if (startDS.getDate() === endDS.getDate()) {
        if (startTimeAMPM[0].ampm === endTimeAMPM[0].ampm) {
            return `${startTimeAMPM[0].time}-${endTimeAMPM[0].time} ${endTimeAMPM[0].ampm}`
        } else {
            return `${startTimeAMPM[0].time} ${startTimeAMPM[0].ampm}-${endTimeAMPM[0].time} ${endTimeAMPM[0].ampm}`
        }
    } else {
        return ''
    }
}

export const compareDate = (startDate, endDate) => {
    const startDS = new Date(startDate.replace(/\s/, 'T'))
    const endDS = new Date(endDate.replace(/\s/, 'T'))

    if (startDS.getDate() === endDS.getDate()) {
        return false
    } else {
        let startString =
            startDS.toLocaleString('default', { month: 'long' }) +
            ' ' +
            startDS.getDate()
        let endString = endDS.getDate() + ', ' + endDS.getFullYear()
        if (startDS.getMonth() !== endDS.getMonth()) {
            endString =
                endDS.toLocaleString('default', { month: 'long' }) +
                ' ' +
                endString
        }
        if (startDS.getFullYear() !== endDS.getFullYear()) {
            startString += ', ' + startDS.getFullYear()
        }

        const dateString = startString + '-' + endString
        return dateString
    }
}

export const formatAMPM = date => {
    let hours = date.getHours()
    let minutes = date.getMinutes()
    const ampm = hours >= 12 ? 'p.m.' : 'a.m.'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes

    let strTime = hours
    if (minutes && minutes !== '00') {
        strTime += ':' + minutes
    }
    const timeObj = [
        {
            time: strTime,
            ampm: ampm,
        },
    ]
    return timeObj
}

export const shortDate = (date, showYear = false) => {
    if (!date) {
        return null
    }
    let tmpDate
    if (typeof date !== 'string') {
        tmpDate = new Date(date)
    } else {
        tmpDate = new Date(date.replace(/\s/, 'T'))
    }

    const monthNames = [
        'Jan.',
        'Feb.',
        'Mar.',
        'Apr.',
        'May',
        'June',
        'July',
        'Aug.',
        'Sept.',
        'Oct.',
        'Nov.',
        'Dec.',
    ]
    const month = monthNames[tmpDate.getMonth()]
    const dd = tmpDate.getDate()

    if (showYear) {
        const year = tmpDate.getFullYear()
        return `${month} ${dd}, ${year}`
    }
    return `${month} ${dd}`
}

export const membershipFeeCalc = (graduate, age, type) => {
    const fees = {
        full: 0,
        installments: 0,
        oneYear: 0,
        twoYear: 0,
        stringParams: {
            full: '',
            installments: '',
            oneYear: '',
            twoYear: '',
        },
    }
    if (graduate) {
        if (type === 'individual') {
            if (age) {
                fees.full = 550
                fees.installments = 29
                fees.oneYear = 45
                fees.twoYear = 79
                fees.stringParams = {
                    full: '?term=life&level=senior',
                    installments: '?term=life&level=senior&installments=yes',
                    oneYear: '?&level=senior',
                    twoYear: '?&level=senior&term=2year',
                }
                // gradYes & ageYes & individual
            } else {
                fees.full = 650
                fees.installments = 34
                fees.oneYear = 25
                fees.twoYear = 44
                fees.stringParams = {
                    full: '?term=life&level=grad',
                    installments: '?term=life&level=grad&installments=yes',
                    oneYear: '?&level=grad',
                    twoYear: '?&level=grad&term=2year',
                }
                // gradYes & ageNo & individual
            }
        } else {
            if (age) {
                fees.full = 650
                fees.installments = 34
                fees.oneYear = 55
                fees.twoYear = 94
                fees.stringParams = {
                    full: '?term=life&level=senior&joint=yes',
                    installments:
                        '?term=life&level=senior&joint=yes&installments=yes',
                    oneYear: '?&level=senior&joint=yes',
                    twoYear: '?&level=senior&joint=yes&term=2year',
                }
                // gradYes & ageYes & joint
            } else {
                fees.full = 750
                fees.installments = 39
                fees.oneYear = 35
                fees.twoYear = 59
                fees.stringParams = {
                    full: '?term=life&level=grad&joint=yes',
                    installments:
                        '?term=life&level=grad&joint=yes&installments=yes',
                    oneYear: '?&level=grad&joint=yes',
                    twoYear: '?&level=grad&joint=yes&term=2year',
                }
                // gradYes & ageNo & joint
            }
        }
    } else {
        if (type === 'individual') {
            if (age) {
                fees.full = 550
                fees.installments = 29
                fees.oneYear = 45
                fees.twoYear = 79
                fees.stringParams = {
                    full: '?term=life&level=senior',
                    installments: '?term=life&level=senior&installments=yes',
                    oneYear: '?&level=senior',
                    twoYear: '?&level=senior&term=2year',
                }
                // gradNo & ageYes & individual
            } else {
                fees.full = 790
                fees.installments = 41
                fees.oneYear = 55
                fees.twoYear = 94
                fees.stringParams = {
                    full: '?term=life',
                    installments: '?term=life&installments=yes',
                    oneYear: '',
                    twoYear: '?term=2year',
                }
                // gradNo & ageNo & individual
            }
        } else {
            if (age) {
                fees.full = 650
                fees.installments = 34
                fees.oneYear = 55
                fees.twoYear = 94
                fees.stringParams = {
                    full: '?term=life&level=senior&joint=yes',
                    installments:
                        '?term=life&level=senior&joint=yes&installments=yes',
                    oneYear: '?&level=senior&joint=yes',
                    twoYear: '?&level=senior&joint=yes&term=2year',
                }
                // gradNo & ageYes & joint
            } else {
                fees.full = 890
                fees.installments = 46
                fees.oneYear = 65
                fees.twoYear = 109
                fees.stringParams = {
                    full: '?term=life&joint=yes',
                    installments: '?term=life&joint=yes&installments=yes',
                    oneYear: '?&joint=yes',
                    twoYear: '?&joint=yes&term=2year',
                }
                // gradNo & ageNo & joint
            }
        }
    }

    return fees
}

export const stripTrailingSlash = url =>
    url.endsWith('/') ? url.slice(0, -1) : url

/* returns events with start dates 90 or more days in the future */
export const tripDateFilter = el => {
    const startDS = new Date(el?.startDate.replace(/\s/, 'T'))
    const futuredate = new Date()
    futuredate.setDate(new Date().getDate() + 90) // 90 = three months, ish
    return startDS >= futuredate
}

/* returns events with dates today or in the future */
export const eventDateFilter = el => {
    const startDS = new Date(el?.startDate.replace(/\s/, 'T'))
    const todaydate = new Date()
    todaydate.setDate(new Date().getDate()) // 90 = three months, ish
    return startDS >= todaydate
}
/**
 * Formats a date based on the start and end date of an event.
 *
 * @param {String} startDate Date string
 * @param {String} endDate   Date String
 * @returns {String} The formatted string.
 */
export const formatEventDate = (startDate, endDate = '') => {
    if (!isValidDateString(startDate)) {
        return ''
    }

    if (!isValidDateString(endDate)) {
        endDate = startDate
    }

    let startYear = new Date(startDate).getFullYear()
    let endYear = new Date(endDate).getFullYear()
    let currentYear = new Date().getFullYear()

    // Single day event. Only show year if different than current year.
    if (isSameDay(startDate, endDate)) {
        return currentYear === startYear
            ? shortDate(startDate)
            : shortDate(startDate, true)
    }

    // Show start year and end year.
    // Start and finish in different year and not in current year.
    if (startYear !== currentYear && startYear !== endYear) {
        return addHTMLToMultiDayEventString(
            shortDate(startDate, true),
            shortDate(endDate, true),
        )
    }

    // Don't show year because both start and end equal
    // current year and start year equals end year.
    if (endYear === currentYear) {
        return addHTMLToMultiDayEventString(
            shortDate(startDate),
            shortDate(endDate),
        )
    }

    // Start year equals current year, but end year does not equal current year.
    return addHTMLToMultiDayEventString(
        shortDate(startDate),
        shortDate(endDate, true),
    )
}

/**
 * Adds html to the start and end date of an event string.
 *
 * @param {String} startDate
 * @param {String} endDate
 * @returns The html string.
 */
const addHTMLToMultiDayEventString = (startDate, endDate) =>
    `<nobr>${startDate}</nobr> &ndash; <nobr>${endDate}</nobr>`

/**
 * Checks to see if dates are on the same day.
 *
 * @param {String} date1
 * @param {String} date2
 * @returns True or false
 */
const isSameDay = (date1, date2) => {
    if (!isValidDateString(date1) || !isValidDateString(date2)) {
        return false
    }

    const startDate = new Date(date1)
    const endDate = new Date(date2)

    return (
        startDate.getFullYear() === endDate.getFullYear() &&
        startDate.getMonth() === endDate.getMonth() &&
        startDate.getDate() === endDate.getDate()
    )
}

/**
 * Checks to see if the date is valid.
 *
 * @param {String} dateString
 * @returns True or false.
 */
const isValidDateString = dateString => {
    return (
        '' !== dateString && 'Invalid Date' !== new Date(dateString).toString()
    )
}

/**
 * Sorts events by 'startDate' property.
 * Note: If startDate is in the past, a future end date
 * gets checked as well. If so, it will sort as if the
 * event is happening now.
 *
 * @param {array} events An array of event objects.
 */
export const sortEventsByDate = events => {
    if (!Array.isArray(events)) {
        return events
    }

    const validEvents = events.filter(event => {
        if (!event.hasOwnProperty('startDate')) return false

        const date = new Date(event.startDate.replace(/\s/, 'T'))

        if ('Invalid Date' == date) {
            return false
        }

        event.sortDate = date

        if (inPast(date)) {
            if (event.hasOwnProperty('endDate')) {
                const end = new Date(event.endDate.replace(/\s/, 'T'))

                if ('Invalid Date' != end) {
                    event.sortDate = new Date()
                }
            }
        }

        return true
    })

    return validEvents.sort(
        (event1, event2) => event1.sortDate - event2.sortDate,
    )
}

/**
 * Checks to see if date is in the past.
 *
 * @param {Date} date
 * @returns boolean
 */
const inPast = date => {
    if (!date instanceof Date) {
        return false
    }
    return date.getTime() < new Date().getTime()
}

export function classNames(...classes) {
    return classes.map(applyStyles).flat().filter(Boolean).join(' ')
}
function applyStyles(styles) {
    if (typeof styles != 'object') {
        return styles
    }

    return Object.keys(styles).filter(style => !!styles[style])
}

/**
 * Sanitizes a URL.
 *
 * 1. Trim the URL.
 * 2. Remove any HTML tags from the URL.
 * 3. Try to parse the URL. new URL will throw an error if the URL is invalid.
 * 4. If the URL is valid, return the encoded URL.
 *
 * @param {string} url The URL to sanitize.
 * @retrun {string}
 */
export function sanitizeURL(url) {
    if (typeof url !== 'string') {
        return url
    }
    url = url.trim()
    url = url.replace(/<\/?[^>]+(>|$)/g, ' ')

    try {
        url = new URL(url)
        return url.toString()
    } catch (_) {
        return ''
    }
}
